import { useEffect, useState } from 'react'
import { Card, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import CustomButton from 'components/Buttons/CustomButton'
import { useShareSchemaMutation } from './schemaListApiSlice'
import { useSnackbar } from 'notistack'
import ShareContactPicker, {
  buildParticipantFromContact,
  getContactUserId,
} from '../projects-menu/ShareContactPicker'

const ModalShareMasterItem = ({
  isOpen,
  toggle,
  dataSchemaById: data,
  onSuccess,
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const [shareSchema, { isLoading }] = useShareSchemaMutation()

  const [participants, setParticipants] = useState([])

  // The share endpoint takes a single userId, so a new pick replaces the current recipient
  const handleSelectContact = (contact) => {
    if (!getContactUserId(contact)) return
    setParticipants([buildParticipantFromContact(contact)])
  }

  const handleRemove = () => setParticipants([])

  const handleSubmit = async () => {
    try {
      await shareSchema({ userId: participants[0]?.userId, processschemaId: data?.id }).unwrap()
      enqueueSnackbar('Skema berhasil dibagikan!', { variant: 'success' })
      onSuccess()
      toggle()
    } catch (error) {
      enqueueSnackbar(
        error?.data?.meta?.message || error?.data?.message || error?.message || 'Skema gagal dibagikan!',
        { variant: 'error' },
      )
    }
  }

  useEffect(() => {
    if (!isOpen) setParticipants([])
  }, [isOpen])

  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      data-testid="master-item-modal-share"
    >
      <ModalHeader toggle={toggle}>
        <span>Bagikan Skema {data?.createMethodLabel}</span>
      </ModalHeader>
      <ModalBody>
        <Card className="shadow-sm border-0 mb-4" body>
          <Row>
            <Col className="mb-2">
              <span>Jumlah Bahan Baku:</span>
            </Col>
            <Col className="mb-2">
              <span className="fw-semibold">{data?.numInput}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <span>Jumlah Barang Jadi:</span>
            </Col>
            <Col>
              <span className="fw-semibold">{data?.numOutput}</span>
            </Col>
          </Row>
        </Card>

        <ShareContactPicker
          isOpen={isOpen}
          participants={participants}
          onSelectContact={handleSelectContact}
          onRemove={handleRemove}
          closeOnSelect
        />

        <div className="d-flex gap-2 mt-4">
          <CustomButton
            block
            className="btn-cancel"
            onClick={toggle}
            testId="master-item-modal-share-cancel-button"
          >
            Batal
          </CustomButton>
          <CustomButton
            disabled={participants.length === 0 || isLoading}
            block
            color="primary"
            onClick={handleSubmit}
            testId="master-item-modal-share-submit-button"
          >
            {isLoading ? 'Membagikan...' : 'Bagikan'}
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalShareMasterItem
